module.exports = __webpack_public_path__ + "media/landing_page/household-b06d8bd5.webp";